<template>
  <dashboard-panel
    title="Tasks"
    icon="fa-check-circle"
    :tabs="canAccess() ? tabs : []"
    :active-tab="mine_only == 1 ? 'you' : 'all'"
    :count="count"
    add-label="add a task"
    :add-permissions="['can_add_tasks']"
    :filterable="enable_filter"
    :can-export="tasks.pending.length > 0 || tasks.completed.length > 0"
    :downloading="loadingDownload"
    :adding-to-vault="loadingAddToVault"
    @download="downloadTask"
    @add-to-vault="addToVault"
    :loading="fetching"
    :empty="tasks.pending.length == 0 && tasks.completed.length == 0"
    empty-text="No tasks found"
    :busy="busy"
    :busy-text="processing_msg"
    @tab="selectTab"
    @add="addTask"
  >
    <template #filter>
      <label class="block text-xxs uppercase tracking-wide text-grey-dark font-semibold mb-1">Show</label>
      <div class="flex items-center h-10">
        <label class="flex items-center text-sm mr-4">
          <input
            class="mr-1"
            name="type"
            type="radio"
            value="pending"
            v-model="type"
            @change="getTasks()"
          />
          Pending
        </label>
        <label class="flex items-center text-sm mr-4">
          <input
            class="mr-1"
            name="type"
            type="radio"
            value="done"
            v-model="type"
            @change="getTasks()"
          />
          Done
        </label>
        <label class="flex items-center text-sm mr-4">
          <input
            class="mr-1"
            name="type"
            type="radio"
            value=""
            v-model="type"
            @change="getTasks()"
          />
          Any
        </label>
      </div>
    </template>

    <div class="py-4">
      <div v-if="type == 'pending' || type == ''">
        <p
          class="border-b border-orange pb-2 font-semibold text-xs text-orange mx-4"
        >
          <i class="fa fa-hourglass-half mr-2"></i> Pending
        </p>
        <div v-if="tasks.pending != undefined && tasks.pending.length > 0">
          <dashboard-list-item
            v-for="task in tasks.pending"
            :key="task.id"
            :author="getUser(task.created_by_user_id)"
            :date="task.due_at"
            date-prefix="due "
            :title="task.title"
            :body="task.description"
            @click="view(task)"
          >
            <template #title>
              <i
                class="fa fa-paperclip text-brand text-xs"
                v-if="task.files.length != 0"
              ></i>
            </template>
            <template #badge>
              <i class="fas fa-hourglass-half text-orange text-sm ml-2"></i>
            </template>
          </dashboard-list-item>
        </div>
        <p v-else class="text-center py-2 text-xs text-grey-dark">
          No pending tasks
        </p>
      </div>

      <div v-if="type == 'done' || type == ''">
        <p
          class="border-b border-green pb-2 mt-6 font-semibold text-xs text-green mx-4"
        >
          <i class="fa fa-check mr-2"></i> Completed
        </p>
        <div
          v-if="tasks.completed != undefined && tasks.completed.length > 0"
        >
          <dashboard-list-item
            v-for="task in tasks.completed"
            :key="task.id"
            :author="getUser(task.created_by_user_id)"
            :date="task.done_at || task.updated_at"
            date-prefix="done "
            :title="task.title"
            :body="task.description"
            @click="view(task)"
          >
            <template #title>
              <i
                class="fa fa-paperclip text-brand text-xs"
                v-if="task.files.length != 0"
              ></i>
            </template>
            <template #badge>
              <i class="fas fa-check-circle text-green text-sm ml-2"></i>
            </template>
          </dashboard-list-item>
        </div>
        <p v-else class="text-center py-2 text-xs text-grey-dark">
          No completed tasks
        </p>
      </div>
    </div>

    <template #modals>
      <add-task
        :all-users="allUsers"
        ref="add_task_component"
        @processing="processing"
        @post-task="postTask"
      ></add-task>

      <view-task
        :viewer="viewer_base"
        :all-users="allUsers"
        ref="view_task_component"
        :selected-task="current_selected_task"
        @processing="processing"
        @end-processing="busy = false"
        @get-tasks="getTasks"
        @marked-as-done="markedAsDone"
      ></view-task>
    </template>
  </dashboard-panel>
</template>

<script>
import { mapGetters } from "vuex";
import DashboardPanel from "./DashboardPanel.vue";
import DashboardListItem from "./DashboardListItem.vue";
import AddTask from "./Tasks/Add";
import ViewTask from "./Tasks/View";
import moment from "moment";

export default {
  components: {
    DashboardPanel,
    DashboardListItem,
    AddTask,
    ViewTask,
  },

  props: {
    viewer_base: {
      type: String,
      default: "/pdf_viewer_3/viewer.html?file=",
    },

    vaultUsers: {
      type: Array,
    },

    allUsers: {
      type: Array,
    },
  },

  data() {
    return {
      tasks: {
        pending: [],
        completed: [],
      },

      current_selected_task: {},
      type: "",

      mine_only: 1,
      enable_filter: true,
      count: 0,
      tabs: [
        { key: "you", label: "You" },
        { key: "all", label: "All" },
      ],

      busy: false,
      processing_msg: "",
      fetching: false,
      loadingDownload: false,
      loadingAddToVault: false,
    };
  },

  mounted() {
    this.init(); 
  },

  methods: {
    async init() {
      const userRole = await this.checkVaultUserRole();
      if(userRole == 'userG') {
        this.mine_only = 0;
      }

      this.getTasks();
    },
    checkVaultUserRole() {
      return axios
        .get(`/api/vaults/${this.$route.params.vault_id}/my-role`)
        .then(({ data }) => {
          if (data) {
            let vault_id = this.vault.id;
            let role_name = data.name;
            let replace_char = vault_id + "-";

            let role = _.camelCase(role_name.replace(replace_char, ""));

            return role;
          }
        });
    },
    selectTab(key) {
      if (key == "you") {
        this.mine_only = 1;
        this.enable_filter = true;
      } else {
        this.mine_only = 0;
        this.enable_filter = _.includes(["userA", "userB"], this.role);
      }

      this.getTasks();
    },
    markedAsDone() {
      this.$emit("task-marked-as-done");
    },
    downloadTask() {
      this.loadingDownload = true;
      setTimeout(() => {
        let url = `api/vaults/${this.$route.params.vault_id}/tasks?type=${this.type}&download=true`;

        if (this.mine_only == 0) {
          url = `api/vaults/${this.$route.params.vault_id}/tasks/all?type=${this.type}&download=true`;
        }

        this.$noty.success(`Your download will begin shortly.`);

        window.open(url, "_blank");
        this.loadingDownload = false;
      }, 500);
    },
    addToVault() {
      this.loadingAddToVault = true;

      let url = `api/vaults/${this.$route.params.vault_id}/tasks/add-to-vault?type=${this.type}`;
      if (this.mine_only == 0) {
        url = `${url}&all=true`;
      }

      axios
        .post(url)
        .then((response) => {
          if (response && response.data) {
            const data = response.data;

            if (data.success) {
              this.$noty.success(data.message);
              this.$ebus.$emit("refresh-file-and-tag-panel");
            } else {
              this.$noty.error(data.message);
            }
          }
        })
        .catch((error) => {
          this.$noty.error(`Failed to add Tasks to Vault.`);
        })
        .finally(() => {
          this.loadingAddToVault = false;
        });
    },
    getTasks(cb) {
      this.fetching = true;
      this.count = 0;

      let url = "";
      if (this.mine_only) {
        url = `api/vaults/${this.$route.params.vault_id}/tasks`;
      } else {
        url = `api/vaults/${this.$route.params.vault_id}/tasks/all`;
      }

      axios
        .get(url, {
          params: {
            type: this.type,
          },
        })
        .then(({ data }) => {
          if (_.isNil(cb) || _.isEmpty(data)) {
            this.tasks = {
              pending: [],
              completed: [],
            };
          }

          if (!_.isEmpty(data)) {
            this.sortTasks(data);
            this.count = this.tasks.pending.length;
          }

          if (!_.isNil(cb) && cb == "reopen-task") {
            if (
              !_.isEmpty(this.current_selected_task) &&
              !_.isEmpty(this.tasks) &&
              !_.isNil(this.reOpenTask())
            ) {
              this.view(this.reOpenTask());
            }
          }

          this.fetching = false;
        })
        .catch(({ response }) => {
          this.fetching = false;
          if (response && response.data) {
            let data = response.data;
            if (!data.success) {
              this.$noty.error(data.message);
            }
          }
        });
    },

    reOpenTask() {
      let task = _.chain(this.tasks)
        .map()
        .flattenDeep()
        .filter({ id: this.current_selected_task.id })
        .value();

      return _.head(task);
    },

    postTask(payload) {
      const { task, files, vaultFiles } = payload;

      const formData = new FormData();
      formData.append("title", task.title);
      formData.append("description", task.description);
      formData.append(
        "due_at",
        moment(task.due_at, [
          "DD/MM/YYYY h:mm A",
          "YYYY-MM-DD HH:mm:ss",
        ]).format("YYYY-MM-DD HH:mm:00")
      );

      // attached user
      task.user.forEach((u, index) => formData.append(`users[${index}]`, u.id));

      files.forEach((file, index) => formData.append(`files[${index}]`, file));
      vaultFiles.forEach((file, index) =>
        formData.append(`vault_files[${index}]`, file.id)
      );

      axios
        .post(`api/vaults/${this.$route.params.vault_id}/tasks`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => {
          this.refreshTasks();
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            const { data } = error.response;
            if (!data.success) {
              this.$noty.error(data.message);
            }
          }
        });
    },

    refreshTasks() {
      this.busy = false;

      this.$refs.add_task_component.$refs.add_task.close();

      this.getTasks();

      this.$ebus.$emit("refresh-file-and-tag-panel");
      this.$ebus.$emit("update-task-count");

      this.$noty.success("Task has been posted!", {
        killer: true,
        timeout: 1500,
      });
    },

    getUser(id) {
      let user = _.filter(this.allUsers, { id: id });

      if (!_.isEmpty(user)) {
        if (!user[0].last_name) {
          return user[0].first_name;
        }
        return user[0].first_name + " " + user[0].last_name;
      }

      return "-";
    },

    view(task) {
      this.current_selected_task = { ...task };
      this.$refs.view_task_component.$refs.view_task.open();
    },

    sortTasks(data) {
      let sorted_tasks = {
        pending: [],
        completed: [],
      };
      _.each(data, (datum) => {
        if (datum.is_done == 1) {
          sorted_tasks.completed.push(datum);
        } else {
          sorted_tasks.pending.push(datum);
        }
      });

      this.tasks = sorted_tasks;
    },

    resetModalState() {
      this.current_selected_task = {};
    },

    canAccess() {
      if (_.includes(["userA", "userB", "userC", "userD"], this.role)) {
        return true;
      }

      return false;
    },

    addTask() {
      this.$refs.add_task_component.$refs.add_task.open();
    },

    processing(payload) {
      this.processing_msg = payload;
      this.busy = true;
    },
  },

  computed: {
    ...mapGetters({
      user: "getUser",
      role: "getUserRole",
      vault: "getCurrentVault",
    }),
  },

  watch: {
    "$route.params.vault_id"() {
      _.delay(() => {
        this.getTasks();
      }, 1000);
    },
  },
};
</script>

<style lang="scss">
.no-padding-content .sweet-content {
  .conversation {
    height: 400px;
  }
}
// .invalid > .multiselect__tags {
//   border: 1px solid #e3342f;
// }
.iframe-container {
  position: relative;
  padding-bottom: 56.25%; /* proportion value to aspect ratio 16:9 (9 / 16 = 0.5625 or 56.25%) */
  height: 0;
  overflow: hidden;
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

@media (max-width: 768px) {
  .iframe-container {
    height: 75vh;
  }
}
</style>

